var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from 'react';
import { SvgIcon } from '@mui/material';
function LabIconsAddTextIconInner(props) {
    return (React.createElement("svg", __assign({ width: 32, height: 32, viewBox: "0 0 32 32", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12.25 28C11.2835 28 10.5 27.2165 10.5 26.25C10.5 25.2835 11.2835 24.5 12.25 24.5H14V7.5H9.5V10.25C9.5 11.2165 8.7165 12 7.75 12C6.7835 12 6 11.2165 6 10.25V6C6 4.89543 6.89543 4 8 4H24C25.1046 4 26 4.89543 26 6V10.25C26 11.2165 25.2165 12 24.25 12C23.2835 12 22.5 11.2165 22.5 10.25V7.5H18V24.5H19.75C20.7165 24.5 21.5 25.2835 21.5 26.25C21.5 27.2165 20.7165 28 19.75 28H12.25Z", fill: "" })));
}
export var LabIconsAddTextIcon = function (props) { return (React.createElement(SvgIcon, __assign({ inheritViewBox: true, component: LabIconsAddTextIconInner }, props))); };
//# sourceMappingURL=LabIconsAddTextIcon.js.map